<template>
  <div class="login">
    <div class="formBox">
      <div class="form">
        <div class="title">身份验证</div>
        <div class="item">
          <input type="password" id="password" required autocomplete="off" v-model="password">
          <label for="password">密码</label>
        </div>
        <button class="btn" @click="submit">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import {PASSWORD} from "@/xunwang-config/const"
import {mapGetters,mapMutations} from "vuex"
export default {
  name: "Login",
  data(){
    return{
      password: "",
    }
  },
  created(){
    if(!this.token){
      this.$message(this.msg)
    }
    console.log("%cLogin","background: #112434;color: #ffffff;")
  },
  computed:{
    ...mapGetters('user',{msg: "msg",token: "token"})
  },
  methods:{
    ...mapMutations('user',{LOGIN: "LOGIN"}),
    //提交
    submit(){
      //验证表单数据
      if(this.password === "" || this.password === null) return this.$message({message: "请输入密码",type: "warning"})
      if(this.password === PASSWORD){
        //验证通过
        //设置过期时间为 8 个小时
        const expire = new Date().getTime() + (1000 * 60 * 60 * 8)
        const data = {
          expire,
        }
        this.LOGIN(data)
        this.$message({message: "验证通过",type: "success"})
        this.$router.replace({
          name: "Home"
        })
      }else{
        this.$message({
          message: "密码错误",
          type: "error"
        })
      }
    }
  }
}
</script>

<style scoped>
  .login{
    width: 100vw;
    height: 100vh;
    background: #333333;
  }
  /*表单盒子*/
  .formBox{
    width: 302px;
    height: 302px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: #112434;
    border-radius: 5%;
    overflow: hidden;
    box-shadow: 0 0 12px #363F48;
  }
  .formBox::after,.formBox::before{
    content: "";
    width: 100%;
    height: 100%;
    background: linear-gradient(rgb(183,140,247),transparent,transparent);
    position: absolute;
    top: 50%;
    left: 50%;
    animation: rotation 4s linear infinite;
    transform-origin: top left;
  }
  .formBox::after{
    background: linear-gradient(transparent,transparent,rgb(255,124,148));
    left: -50%;
    top: -50%;
    transform-origin: bottom right;
  }
  @keyframes rotation {
    0%{
      transform: rotate(0deg);
    }
    100%{
      transform: rotate(-360deg);
    }
  }
  /*表单主体*/
  .formBox .form{
    width: 300px;
    height: 300px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: #333333;
    z-index: 9;
    border-radius: inherit;
  }
  /*标题*/
  .title{
    color: #ffffff;
    text-align: center;
    font-weight: bold;
    font-size: 35px;
    line-height: 2;
    margin-top: 30px;
  }
  /*输入框*/
  .item{
    position: relative;
    margin: 25px auto;
    width: 80%;
    color: #ffffff;
  }
  .item input{
    width: 100%;
    border-radius: 5px;
    background: #333333;
    height: 40px;
    border: 1px solid #112434;
    box-sizing: border-box;
    padding-left: 10px;
    outline: none;
    color: #ffffff;
  }
  .item label{
    font-size: 16px;
    line-height: 40px;
    position: absolute;
    top: 0;
    left: 20px;
    pointer-events: none;
    transition: all 0.5s;
  }
  .item input:focus{
    box-shadow: 0 0 10px 1px #363F48;
    border: 1px solid #363F48;
  }
  .item input:focus + label,
  .item input:valid + label{
    font-size: 12px;
    line-height: 24px;
    top: -15px;
    background-color: #333333;
  }
  /*提交按钮*/
  .btn{
    width: 70%;
    font-size: 18px;
    line-height: 2;
    color: #ffffff;
    font-weight: bold;
    border-radius: 5px;
    background: #112434;
    margin: 40px auto;
    display: block;
  }
  .btn:focus{
    outline: none;
  }
</style>